<template>
  <div class="home">
    <div v-if="canView">
      <div class="home__filter filter">
        <InputText
          v-model="filter.fio"
          placeholder="Введите ФИО"
          class="filter__field filter__field--fio"
          label="ФИО"
          @keyupEnter="onFindClick"
        />
        <div class="filter__field">
          <label class="control-label">Дата рождения</label>
          <date-component
            v-model="filter.dateOfBirth"
            @keyupEnter="onFindClick"
          />
        </div>
        <InputText
          v-model="filter.snils"
          class="filter__field"
          placeholder="СНИЛС"
          label="СНИЛС"
        />
        <button-component class="filter__search" @click="onFindClick">
          Найти
        </button-component>
      </div>

      <div v-if="patients.itemCount === 0" class="home__data-not-found">
        <AtomIcon name="warning" /> Данные не найдены!
      </div>

      <div v-if="patients.items?.length > 0" class="table-inner">
        <table class="table-custom">
          <thead>
            <tr>
              <th>№</th>
              <th>ФИО</th>
              <th>Дата рождения</th>
              <th>СНИЛС</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in patients.items"
              :key="item.id"
              @dblclick="() => viewPatientCard(item.id)"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.surname }} {{ item.name }} {{ item.patronimic }}</td>
              <td>{{ $momentFormat(item.dateOfBirth, "DD.MM.YYYY") }}</td>
              <td>
                <div class="snils">
                  {{ item.snils }}
                </div>
              </td>
              <td>
                <button class="btn" @click="viewPatientCard(item.id)">
                  <i class="fa fa-eye"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="patients.pagesTotal > 1">
        <Pagination
          :page-count="patients.pagesTotal"
          :current-page="patients.pageNumber"
          @change="onPageChange($event)"
        />
      </div>
    </div>

    <section class="modals">
      <modal-component
        v-if="modals.show"
        title=""
        size-class="modal-xl"
        @close="modals.show = false"
      >
        <patient-short-card :id="modals.id" @close="modals.show = false" />
      </modal-component>
    </section>

    <div style="margin: 38px auto 0; text-align: center">
      <Dashboard v-if="canView" />
    </div>
  </div>
</template>

<script>
import Constants from "@/common/constants";
import security from "@/common/mixins/security";
import axios from "axios";
import DateComponent from "@/common/components/DateComponent";
import ModalComponent from "@/common/ui/ModalComponent";
import PatientShortCard from "@/modules/ras/components/PatientShortCard";
import Dashboard from "../modules/dashboard/views/Dashboard.vue";
import InputText from "../common/ui/InputText.vue";
import ButtonComponent from "../common/ui/ButtonComponent.vue";
import AtomIcon from "../common/ui/Icon.vue";

export default {
  name: "Home",
  components: {
    ButtonComponent,
    DateComponent,
    ModalComponent,
    PatientShortCard,
    Dashboard,
    InputText,
    AtomIcon,
  },
  mixins: [security],
  data: () => ({
    canView: false,
    filter: {
      dateOfBirth: null,
      fio: "",
      snils: "",
      pageNumber: 1,
      pageSize: 5,
    },
    patients: {},
    modals: {
      id: null,
      show: false,
    },
  }),
  created() {
    this.checkPermission(Constants.DashboardView).then((response) => {
      this.canView = response.data;
    });
  },
  methods: {
    search() {
      //таблица для поиска
      axios
        .get("/api/ras/searchDashboard", { params: this.filter })
        .then((response) => {
          this.patients = response.data;
        });
    },
    viewPatientCard(id) {
      this.modals.id = id;
      this.modals.show = true;
    },
    onPageChange(pageNumber) {
      this.filter.pageNumber = pageNumber;
      this.search();
    },

    onFindClick() {
      this.filter.pageNumber = 1;
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  padding: 33px 48px;
  &__filter {
    width: 100%;
    display: flex;
    gap: 25px;
    padding-bottom: 24px;
    align-items: flex-end;
  }
  &__data-not-found {
    display: flex;
    gap: 6px;
    align-items: center;
    font-size: 16px;
    line-height: 19.2px;
    font-weight: 600;
  }
}
.filter {
  &__field {
    flex: 1;
    &--fio {
      flex: 2;
    }
  }
  // &__search {
  //   height: 38px;
  //   padding-top: 0;
  //   padding-bottom: 0;
  // }
}
.table-custom {
  .snils {
    display: flex;
    justify-content: space-between;
  }
  .view-card {
    color: #2580e8;
    cursor: pointer;
  }
}
</style>
